module.exports = __webpack_public_path__ + "img/5.564879f8.jpg";